/** Typed wrapper over fetch for /api/broker/dhan/* (2026-10-08).
 *
 * Connect sends the browser to Dhan's own login (like Kite and Fyers) when the API key and secret
 * are set; pasting a 24-hour token from web.dhan.co is the fallback. The token only ever travels
 * in the POST body; no response carries it.
 */

import { getJson } from "@/lib/http";

const BASE = "/api/broker/dhan";

export interface DhanStatus {
  /** False when the deployment has no DHAN_CLIENT_ID: the page hides the Dhan card. */
  configured: boolean;
  connected: boolean;
  user_id: string | null;
  issued_at: string | null;
  expires_at: string | null;
  /** False = F&O is NOT active on the Dhan account, so option orders would be refused. */
  derivatives_active: boolean | null;
  data_valid_until: string | null;
  last_error: string | null;
  /** Connect can send the browser to Dhan's login (API key and secret are set). */
  login_enabled: boolean;
  /** True: the token renews itself each morning. False: it dies in 24 hours, log in again. */
  auto_renew: boolean;
}

export interface DhanLoginUrl {
  login_url: string;
}

export const dhanApi = {
  loginUrl(): Promise<DhanLoginUrl> {
    return getJson<DhanLoginUrl>(`${BASE}/login`);
  },
  status(): Promise<DhanStatus> {
    return getJson<DhanStatus>(`${BASE}/status`);
  },
  pasteToken(accessToken: string): Promise<DhanStatus> {
    return getJson<DhanStatus>(`${BASE}/token`, {
      method: "POST",
      body: JSON.stringify({ access_token: accessToken }),
    });
  },
  renew(): Promise<DhanStatus> {
    return getJson<DhanStatus>(`${BASE}/renew`, { method: "POST" });
  },
  refresh(): Promise<DhanStatus> {
    return getJson<DhanStatus>(`${BASE}/refresh`, { method: "POST" });
  },
  logout(): Promise<DhanStatus> {
    return getJson<DhanStatus>(`${BASE}/logout`, { method: "POST" });
  },
};
